import { useIsRootUser } from '../hooks/use-is-root-user'

export const RootOnly: React.FC = ({ children }) => {
  const isRootUser = useIsRootUser()
  return isRootUser ? <>{children}</> : null
}
